import React, { useCallback, useState } from 'react';
import ScrollAnimation from '../ScrollAnimation/ScrollAnimation.js';
import { IImage } from '../../types/content';
import { ReactComponent as GamesIcon } from '../../assets/games-icon.svg';
import { ReactComponent as DiamondIcon } from '../../assets/diamond-icon.svg';
import { ReactComponent as RewardIcon } from '../../assets/reward-icon.svg';
import { ReactComponent as ReplayIcon } from '../../assets/replay-icon.svg';
import { getNavigationPageLink, redirectUser } from '../../utils';
import CONFIG from '../../config';
import { Redirect } from '../../types/enums';

interface IAboutItemProps {
  item: {
    image: IImage;
    title: string;
    description: string;
  };
}

interface IIcon {
  icon : any,
  redirectLink : string,
  externalLink? : boolean
}

const getIconData = (imageLink: string): IIcon => {
  switch (imageLink) {
    case 'games-icon' :
      return {"icon" : <GamesIcon className={'badgeIcon'} /> ,
              "redirectLink" : getNavigationPageLink('games')}
    case 'diamond-icon' :
      return {"icon" : <DiamondIcon className={'badgeIcon'} />,
        "redirectLink" : getNavigationPageLink( 'games')}
    case 'reward-icon' :
      return {"icon" : <RewardIcon className={'badgeIcon'} /> ,
        "redirectLink" : getNavigationPageLink( 'rewards')}
    case 'replay-icon' :
      return{"icon" : <ReplayIcon className={'badgeIcon'}/> ,
        "redirectLink" : 'https://support.ubi.com/faqs/000049210'}
    default :
      return {"icon" : <GamesIcon className={'badgeIcon'} /> ,
        "redirectLink" : getNavigationPageLink('games'),
        externalLink : !CONFIG.isUPC}

  }
}


const AboutItem = ({ item }: IAboutItemProps) => {
  const minMobile =  601;
  const [clickedButton,setButtonClicked] = useState(false);
  let iconData = getIconData(item.image.link);

  const aboutItemClick = useCallback(() => {
    if(iconData.redirectLink){
      setButtonClicked(true)
      redirectUser(iconData.redirectLink, iconData.externalLink ? Redirect.EXTERNAL : undefined);
    }
  },[redirectUser, iconData, setButtonClicked])

  return (
    <div className={`
    ${(clickedButton) ? 'aboutItemClicked' : ''} 
    about_ubisoft-plus_boxes_item`} onClick={() => aboutItemClick()}>
      <ScrollAnimation
        className="icon-wrapper"
        animateIn="scaleUp"
        animatePreScroll={!(window.innerWidth > minMobile)}
      >
        {iconData.icon}
      </ScrollAnimation>
      <ScrollAnimation
        className="content"
        animateIn="fadeUp"
        animateOnce={true}
        animatePreScroll={!(window.innerWidth > minMobile)}
      >
        <div className={'badge-item-container'}>
          <h3 className={`about-item-title bolden-text`}>{item.title}</h3>
          <p dangerouslySetInnerHTML={{ __html: item.description }} />
        </div>
      </ScrollAnimation>
    </div>
  );
};

export default AboutItem;
